import { useState } from "react";
import {
  IconNameEnum,
  useHotelsStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { Icon } from "@b2bportal/core-ui";
import type { Lodging } from "@b2bportal/lodging-api";
import { TripAdvisorRatingOneRow } from "@tenant/hotels";
import clsx from "clsx";
import { useHotelInfoSection } from "./hooks";
import defaultStyles from "./HotelInfoSection.module.scss";
import { Rewards } from "@/components";
import { EarnPointsDialogControlled } from "@/components/PerkDialogs";

export interface HotelInfoSectionProps extends PlatformComponentProps {
  hotel: Lodging;
}

const COMPONENT_KEY = CoreHotelsComponent.HotelInfoSection;

export const HotelInfoSection = (props: HotelInfoSectionProps) => {
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const [isRewardsDialogOpen, setIsRewardsDialogOpen] = useState(false);
  const handleOpenDialog = () => {
    setIsRewardsDialogOpen(true);
  };
  const handleCloseDialog = () => {
    setIsRewardsDialogOpen(false);
  };

  const { children, className } = props;

  const { context, text } = useHotelInfoSection(props);

  return (
    <div className={clsx(block, className)}>
      <div className={cn("left-content")}>
        <h1 className={cn("name")}>{text.hotelName}</h1>
        <div className={cn("hotel-ratings")}>{text.starRating}</div>
        {context.tripAdvisorReviews != null ? (
          <div className={cn("tripadvisor-ratings")}>
            <TripAdvisorRatingOneRow
              tripAdvisorReviews={context.tripAdvisorReviews}
            />
          </div>
        ) : null}
      </div>
      <div className={cn("right-content")}>
        <Rewards
          amount={context.rewardsAmount}
          className={cn("rewards")}
          onClick={handleOpenDialog}
          highlightClassName={cn("rewards-highlight")}
        />
        {context.isFreeCancel && (
          <div className={cn("free-cancellation")}>
            <Icon iconName={IconNameEnum.check} /> {text.freeCancellation}
          </div>
        )}
      </div>
      {children}
      <EarnPointsDialogControlled
        open={isRewardsDialogOpen}
        onClose={handleCloseDialog}
      />
    </div>
  );
};
